var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60937 10.5C6.91844 10.5051 6.50268 10.5263 6.17152 10.614C4.6643 11.0131 3.6324 12.3639 3.67303 13.8847C3.6848 14.3252 3.85249 14.8696 4.18787 15.9585C4.99501 18.579 6.3515 20.8539 9.39032 21.3997C9.94891 21.5 10.5775 21.5 11.8346 21.5H13.5091C14.7662 21.5 15.3948 21.5 15.9534 21.3997C18.9922 20.8539 20.3487 18.579 21.1558 15.9585C21.4912 14.8696 21.6589 14.3252 21.6707 13.8847C21.7113 12.3639 20.6794 11.0131 19.1722 10.614C18.841 10.5263 18.4253 10.5051 17.7344 10.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6719 3.5V14.5M12.6719 3.5C13.1402 3.5 13.4962 3.9381 14.2083 4.8143L15.1719 6M12.6719 3.5C12.2035 3.5 11.8475 3.9381 11.1354 4.8143L10.1719 6",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload03);
export default __webpack_public_path__ + "static/media/upload-03.caf2d75c8bf3151327372053d51d1394.svg";
export { ForwardRef as ReactComponent };